import { combineReducers } from "redux";
import { i18nReducer } from "react-redux-i18n";
import appReducer from "./appReducer";
import alertReducer from "./alertReducer";
import accountReducer from "./accountReducer";
import languageReducer from "./languageReducer";

export default combineReducers({
  // specific reducers go here
  app: appReducer,
  i18n: i18nReducer,
  alert: alertReducer,
  account: accountReducer,
  language: languageReducer,
});
